<template>
  <div id="main-calendar" class="pc-main-calendar">
    <calendar-day
                  v-show="calendarDayDisp"
                  :currentYear="currentYear"
                  :selectingMonth="selectingMonth"
                  :selectingYear="selectingYear"
                  :setSelectMonth="setSelectMonth"
                  :setSelectYear="setSelectYear"
                  :setSelectDate="setSelectDate"
                  :totalWeek="totalWeek"
                  :firstDate="firstDate"
                  :sumDayInMonth="sumDayInMonth"
                  :days="days"
                  :month="month"
                  :checkCalendarMain="checkCalendarMain"
                  :calArrWeek="calArrWeek"
                  :checkCurrentDay="checkCurrentDay"
                  :checkSelectedDay="checkSelectedDay"
                  :pcDisp="pcDisp"
                  :nowLang="nowLang"
                  :disableCalendarYearButton="disableCalendarYearButton"
                  :autoFocusCalendarTab="autoFocusCalendarTab"
                  :calendarTab1="calendarTab1"
                  :calendarTab2="calendarTab2"
                  :calendarTab3="calendarTab3"
                  :calendarTab4="calendarTab4"
                  :checkCalendarHoliday="checkCalendarHoliday" />
    <calendar-month v-show="calendarMonthDisp"
                    :currentYear="currentYear"
                    :currentMonth="currentMonth"
                    :selectingYear="selectingYear"
                    :setSelectYear="setSelectYear"
                    :setSelectMonth="setSelectMonth"
                    :month="month"
                    :checkCurrentMonth="checkCurrentMonth"
                    :checkSelectedMonth="checkSelectedMonth"
                    :nowLang="nowLang"
                    :disableCalendarYearButton="disableCalendarYearButton"
                    :checkCalendarMain="checkCalendarMain"
                    :autoFocusCalendarTab="autoFocusCalendarTab"
                    :calendarTab1="calendarTab1"
                    :calendarTab2="calendarTab2"
                    :calendarTab3="calendarTab3"
                    :calendarTab4="calendarTab4" />
    <div v-show="!disableCalendarYearButton" class="calendar-holiday-desc">
      {{traditionHoliday}}
    </div>
  </div>
</template>

<script>
import calendarDay from 'components/calendar/mode_day'
import calendarMonth from 'components/calendar/mode_month'

export default {
  name: 'main_calendar',
  props: [
    'calendarDayDisp',
    'calendarMonthDisp',
    'currentYear',
    'currentMonth',
    'selectingMonth',
    'selectingYear',
    'setSelectMonth',
    'setSelectYear',
    'setSelectDate',
    'totalWeek',
    'days',
    'month',
    'checkCalendarMain',
    'calArrWeek',
    'checkCurrentDay',
    'checkSelectedDay',
    'checkCurrentMonth',
    'checkSelectedMonth',
    'pcDisp',
    'nowLang',
    'disableCalendarYearButton',
    'autoFocusCalendarTab',
    'calendarTab1',
    'calendarTab2',
    'calendarTab3',
    'calendarTab4',
    'checkCalendarHoliday',
    'traditionHoliday'
  ],
  components: {
    calendarDay,
    calendarMonth
  }
}
</script>



// WEBPACK FOOTER //
// main_calendar.vue?1baf9636